// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-footer[data-v-7c8e25d0] {\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
